import { render } from "./MVP.vue?vue&type=template&id=618754a3&scoped=true"
import script from "./MVP.vue?vue&type=script&lang=js"
export * from "./MVP.vue?vue&type=script&lang=js"

import "./MVP.vue?vue&type=style&index=0&id=618754a3&scoped=true&lang=css"
import "./MVP.vue?vue&type=style&index=1&id=618754a3&scoped=true&lang=css"
import "./MVP.vue?vue&type=style&index=2&id=618754a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618754a3"]])

export default __exports__